// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"e09fb906","157":"fbe231c6","375":"2601ff4c","452":"f34c77e2","453":"e1559f6e","875":"e613de2a","878":"7d845ae5","934":"fa366768","935":"d56b3279"}[chunkId] + ".chunk.js";
};